import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import EnquiryForm from '../components/EnquiryForm';

const ContactPage = () => {
  const contacts = [
    { name: 'Shamsher Sharma', phone: '8950999600', role: 'Director' },
    { name: 'Shivansh Vats', phone: '8264999600', role: 'Director' },
    { name: 'Rekha Sharma', phone: '7508009999', role: 'Director' },
  ];

  return (
    <div className="min-h-screen" data-testid="contact-page">
      <section className="bg-gradient-to-r from-[#0F5132] to-[#0F5132] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Contact Us</h1>
          <p className="text-xl text-gray-100">Get in touch with our team for any queries or assistance</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl font-bold text-[#0F5132] mb-8">Get in Touch</h2>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#0F5132] rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaMapMarkerAlt className="text-[#0F5132] text-xl" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#0F5132] mb-1">Manufacturing Unit</h3>
                  <p className="text-gray-600">Village Jaspur, Mauli-Ambala Road<br/>Panchkula, Haryana, India</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#0F5132] rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaEnvelope className="text-[#0F5132] text-xl" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#0F5132] mb-1">Email</h3>
                  <p className="text-gray-600">shivangelayurveda.nutra@gmail.com</p>
                  <p className="text-gray-600">shivangeltechnopack@gmail.com</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="font-semibold text-[#0F5132] mb-4">Contact Our Team</h3>
              <div className="space-y-4">
                {contacts.map((contact, index) => (
                  <div key={index} className="flex items-center justify-between bg-white rounded-lg p-4 shadow-sm">
                    <div>
                      <div className="font-semibold text-[#0F5132]">{contact.name}</div>
                      <div className="text-sm text-gray-500">{contact.role}</div>
                    </div>
                    <a
                      href={`tel:+91${contact.phone}`}
                      className="flex items-center space-x-2 px-4 py-2 bg-[#0F5132] text-white rounded-lg hover:bg-[#0D4228] transition-colors"
                    >
                      <FaPhone />
                      <span>{contact.phone}</span>
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-6">
              <a
                href="https://wa.me/918264999600"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-3 w-full px-6 py-4 bg-[#25D366] text-white rounded-lg hover:bg-[#128C7E] transition-colors font-semibold"
              >
                <FaWhatsapp size={24} />
                <span>Chat on WhatsApp</span>
              </a>
            </div>
          </div>

          <div>
            <EnquiryForm title="Send Us a Message" context="general" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;